export default __webpack_public_path__ + "static/media/bg.ee0da443.png";